import * as Linking from 'expo-linking'
import HelperPlatform from 'utils/helper-platform'

export const createUrl = ( path = '' ) => {
	let url = '';

	try {
		url = Linking.createURL( path )
	} catch ( e ) {
		console.warn( e )
	}

	return url
}

export const openUrl = async ( url, target = '_blank' ) => {
	if( HelperPlatform.isWeb() ) {
		window.open( url, target )
		return;
	}
	
	try {
		// Opening directly also avoids iOS URL-query allowlist restrictions.
		await Linking.openURL( url );
		return true;
	} catch ( error ) {
		console.warn( 'Could not open external link', error );
		return false;
	}
}
